enum Currency {
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
  AUD = 'AUD',
}

export default Currency
